module.exports = __webpack_public_path__ + "static/media/uni-campus-2.cfbd6812.jpg";